import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import DropdownList from '../FormElements/DropdownList';
import AdvancedDataTable from '../DataTables/AdvancedDataTable';
import MobileDataTableCard from '../DataTables/MobileDataTableCard';
import Cell from '../DataTables/DataTableComponents/Cell';
import PropertyWidget from '../DataTables/DataTableComponents/PropertyWidget';
import StatusWidget from '../DataTables/DataTableComponents/StatusWidget';
import ActionItemTag from '../Tags/ActionItemTag';
import Tooltip from '../Tooltip/Tooltip';
import TaxRatesTooltip from '../TaxRates/TaxRatesTooltip';
import FilingScheduleTooltip from '../FilingSchedules/FilingSchedulesTooltip';

export default function PropertiesIndexCard(props) {
	const { user } = useAuth();
	const location = useLocation();

	const [
		userAccounts,
		setUserAccounts
	] = useState([]);

	const [
		userPropertiesByAccount,
		setUserPropertiesByAccount
	] = useState([]);

	const [
		userFilingSchedules,
		setUserFilingSchedules
	] = useState([]);

	useEffect(
		() => {
			if (user) {
				fetch(props.get_accounts_by_user_endpoint.replace('user_id', user.id))
					.then((response) => response.json())
					.then((result) => {
						setUserAccounts(result.data || []);
					});
			}
		},
		[
			user,
			props.get_accounts_by_user_endpoint
		]
	);

	useEffect(
		() => {
			if (userAccounts && userAccounts.length > 0) {
				fetch(
					props.get_properties_by_account_endpoint.replace(
						'account_id',
						userAccounts[0].id
					)
				)
					.then((response) => response.json())
					.then((result) => {
						setUserPropertiesByAccount(result.data || []);
					});
			}
		},
		[
			props.get_properties_by_account_endpoint,
			userAccounts
		]
	);

	return (
		<div>
			<DropdownList label="Accounts" data={userAccounts} />
			<div className="contents lg:hidden">
				<MobileDataTableCard
					data={userPropertiesByAccount}
					// endpoint={props.get_properties_endpoint}
					rowRenderer={(row) => {
						console.log('PropertiesCard - property row', row);
						let labels = [
							{
								displayName: 'Property Name',
								apiName: 'property_name',
								alignment: 'left'
							},
							{
								displayName: 'Tax Rate',
								apiName: 'tax_rate',
								alignment: 'left'
							},
							{
								displayName: 'Filing Schedules',
								apiName: 'filing_schedules',
								alignment: 'left'
							},
							{
								displayName: 'Created on',
								apiName: 'created_date',
								alignment: 'left'
							},
							{
								displayName: 'Status',
								apiName: 'status',
								alignment: 'left'
							},
							{
								displayName: 'Action Items',
								apiName: 'action_items',
								alignment: 'left'
							}
						];

						return (
							<div key={row.id} className="p-5 bg-white border-t text-gray-800">
								<div>
									<PropertyWidget
										id={row.id}
										name={row.name}
										city={row.city}
										state={row.state}
										status={row.status}
									/>
								</div>
								<div className="mt-4 font-semibold">
									{labels[1].displayName}
								</div>
								<div>
									<Cell
										value={
											<span className="mr-2">
												14.715%{' '}
												<Tooltip text={<TaxRatesTooltip />} placement="right">
													<i className="fa fa-info-circle text-gray-700" />
												</Tooltip>
											</span>
										}
										type="text"
									/>
								</div>
								<div className="mt-4 font-semibold">
									{labels[2].displayName}
								</div>
								<div>
									<Cell
										value={
											<div>
												<span className="mr-2 block">
													Honululu Monthly Online{' '}
													<Tooltip
														text={<FilingScheduleTooltip />}
														placement="right"
													>
														<i className="fa fa-calendar-o text-gray-700" />
													</Tooltip>
												</span>
												<span className="mr-2 block">
													Maui Annual Online{' '}
													<Tooltip
														text={<FilingScheduleTooltip />}
														placement="right"
													>
														<i className="fa fa-calendar-o text-gray-700" />
													</Tooltip>
												</span>
											</div>
										}
										type="text"
									/>
								</div>
								<div className="mt-4 font-semibold">
									{labels[3].displayName}
								</div>
								<div>
									<Cell value={row.created_at} type="date" />
								</div>
								<div className="mt-4 font-semibold">
									{labels[4].displayName}
								</div>
								<div>
									<StatusWidget status={row.status} />
								</div>
								<div className="mt-4 font-semibold">
									{labels[5].displayName}
								</div>
								<div>
									<Cell
										value={[
											<ActionItemTag
												key={`${row.id} - Sign POA`}
												actionItem="Sign POA"
												isDisplayed={false}
												isEnabled={true}
												url={`/properties/${row.id}/poa`}
												propertyName={row.name}
											/>,
											<ActionItemTag
												key={`${row.id} - Add Ownership Details`}
												actionItem="Add Ownership Details"
												isDisplayed={false}
												isEnabled={false}
												url={`/properties/${row.id}/ownership`}
												propertyName={row.name}
											/>,
											<ActionItemTag
												key={`${row.id} - Complete License Survey`}
												actionItem="Complete License Survey"
												isDisplayed={false}
												isEnabled={false}
												url={`/properties/${row.id}/license-survey`}
												propertyName={row.name}
											/>,
											<ActionItemTag
												key={`${row.id} - Review License Application`}
												actionItem="Review License Application"
												isDisplayed={false}
												isEnabled={false}
												url={`/properties/${row.id}/business-license-application`}
												propertyName={row.name}
											/>,
											!props.hasExistingLicense && (
												<ActionItemTag
													key={`${row.id} - Report Revenue`}
													actionItem="Report Revenue"
													isDisplayed={true}
													isEnabled={true}
													url={'/revenue/report'}
												/>
											)
										]}
									/>
								</div>
							</div>
						);
					}}
				/>
			</div>
			<div className="hidden lg:contents">
				<AdvancedDataTable
					data={userPropertiesByAccount}
					// endpoint={props.get_properties_endpoint}
					style="text-gray-800 border-b-2 border-gray-300 font-semibold"
					columns={[
						{
							displayName: 'Property Name',
							apiName: 'property_name',
							alignment: 'left'
						},
						{
							displayName: 'Tax Rate',
							apiName: 'tax_rate',
							alignment: 'left'
						},
						{
							displayName: 'Filing Schedules',
							apiName: 'filing_schedules',
							alignment: 'left'
						},
						{
							displayName: 'Created on',
							apiName: 'created_date',
							alignment: 'left'
						},
						{
							displayName: 'Status',
							apiName: 'status',
							alignment: 'left'
						},
						{
							displayName: 'Action Items',
							apiName: 'action_items',
							alignment: 'left'
						}
					]}
					rowRenderer={(row) => {
						console.log('PropertiesCard - property row', row);
						return (
							<tr key={row.id} className="bg-white border-t text-gray-800">
								<td className="pl-8 py-3 text-left">
									<PropertyWidget
										id={row.id}
										name={row.name}
										city={row.city}
										state={row.state}
									/>
								</td>
								<td className="pl-8 pr-6 py-3 text-left">
									<Cell
										value={
											<span className="mr-2 block w-24">
												14.715%{' '}
												<Tooltip text={<TaxRatesTooltip />}>
													<i className="fa fa-info-circle text-gray-700" />
												</Tooltip>
											</span>
										}
										type="text"
									/>
								</td>
								<td className="pl-8 pr-6 py-3 text-left">
									<Cell
										value={
											<div>
												<span className="mr-2 block">
													Maui Monthly Online{' '}
													<Tooltip text={<FilingScheduleTooltip />}>
														<i className="fa fa-calendar-o text-gray-700" />
													</Tooltip>
												</span>
												<span className="mr-2 block">
													Maui Annual Online{' '}
													<Tooltip text={<FilingScheduleTooltip />}>
														<i className="fa fa-calendar-o text-gray-700" />
													</Tooltip>
												</span>
											</div>
										}
										type="text"
									/>
								</td>
								<td className="pl-9 pr-6 py-3 text-left">
									<Cell value={row.created_at} type="date" />
								</td>
								<td className="pl-8 pr-6 py-3 text-left w-48">
									<StatusWidget status={row.status} />
								</td>
								<td className="pl-8 pr-6 py-3 text-left w-80">
									<Cell
										value={[
											<ActionItemTag
												key={`${row.id} - Sign POA`}
												actionItem="Sign POA"
												isDisplayed={true}
												isEnabled={true}
												url={`/properties/${row.id}/poa`}
												propertyName={row.name}
											/>,
											<ActionItemTag
												key={`${row.id} - Add Ownership Details`}
												actionItem="Add Ownership Details"
												isDisplayed={true}
												isEnabled={false}
												url={`/properties/${row.id}/ownership`}
												propertyName={row.name}
											/>,
											<ActionItemTag
												key={`${row.id} - Complete License Survey`}
												actionItem="Complete License Survey"
												isDisplayed={true}
												isEnabled={false}
												url={`/properties/${row.id}/license-survey`}
												propertyName={row.name}
											/>,
											<ActionItemTag
												key={`${row.id} - Review License Application`}
												actionItem="Review License Application"
												isDisplayed={true}
												isEnabled={false}
												url={`/properties/${row.id}/business-license-application`}
												propertyName={row.name}
											/>,
											!props.hasExistingLicense && (
												<ActionItemTag
													key={`${row.id} - Report Revenue`}
													actionItem="Report Revenue"
													isDisplayed={false}
													isEnabled={false}
													url={'/revenue/report'}
												/>
											)
										]}
									/>
								</td>
							</tr>
						);
					}}
				/>
			</div>
		</div>
	);
}
